import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@mantine/core';
import { IconArrowRight } from '@tabler/icons-react';
import { useUserStore } from '../../store/userStore';

/** Вход в приложение с публичных страниц: вошедшему — «Открыть приложение», а не форма входа. */
export const useAppEntry = () => {
  const isSignedIn = useUserStore((s) => !!s.token);
  // Тексты публичных страниц пока только на русском, как и сами страницы.
  return isSignedIn
    ? { to: '/dashboard', label: 'Открыть приложение' }
    : { to: '/auth', label: 'Войти' };
};

/** Кнопка в шапке /docs и /policy. */
export const AppEntryButton: React.FC = () => {
  const { to, label } = useAppEntry();
  return (
    <Button
      component={Link}
      to={to}
      size="xs"
      color="teal"
      rightSection={<IconArrowRight size={12} />}
    >
      {label}
    </Button>
  );
};
